import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Custom hook for responsive design.
 * Returns isMobile (< 600px / sm) and isTablet (< 900px / md)
 * Usage:
 *   const { isMobile, isTablet } = useMobile();
 */
export const useMobile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
  return { isMobile, isTablet };
};

export default useMobile;
